const PLACEHOLDER_PATTERNS = [
  /^test\d*$/i,
  /^placeholder\d*$/i,
  /^temp\d*$/i,
  /^dummy\d*$/i,
  /^unknown\d*$/i,
  /^null\d*$/i,
  /^na\d*$/i,
  /^n\/a\d*$/i,
];

export function validateEntityName(
  name: string,
  entityLabel: string = "Name",
): string | null {
  const trimmed = name.trim();
  if (!trimmed) return `${entityLabel} is required`;
  if (/^\d+$/.test(trimmed)) return `${entityLabel} cannot be purely numeric`;
  if (trimmed.length < 2) return `${entityLabel} must be at least 2 characters`;
  if (trimmed.length > 200)
    return `${entityLabel} exceeds 200 characters (${trimmed.length})`;
  for (const pattern of PLACEHOLDER_PATTERNS) {
    if (pattern.test(trimmed)) return "Placeholder names are not allowed";
  }
  return null;
}

export function reindexErrors(
  prev: Record<number, string>,
  removedIndex: number,
): Record<number, string> {
  const next: Record<number, string> = {};
  Object.entries(prev).forEach(([k, v]) => {
    const key = Number(k);
    if (key < removedIndex) next[key] = v;
    else if (key > removedIndex) next[key - 1] = v;
  });
  return next;
}
